// extracted by mini-css-extract-plugin
export default {"form":"style_form__V797D","visible":"style_visible__1iJuS"};